
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { AdminContentCampaignRoute } from '@/modules/content-campaign/routes/admin-content-campaign.route'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminContentCampaignActions extends Vue {
  constructor(
    protected readonly routes: AdminContentCampaignRoute
  ) {
    super()
  }

  @Prop({ required: true }) id!: number
}
